import { Injectable } from '@angular/core';
import {ProjectService, WmHttpService} from "@wms/services";
import { environment } from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class ConnectorService {
  private TARGET: string = "Connector";
  private API_META: any = {
    upload: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/connectors/import",
      method: "POST"
    }
  }
  constructor(private wmHttpService: WmHttpService, private projectService: ProjectService) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }
  upload(uploadConfig: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: uploadConfig.action,
      pathParams: {
        projectID: this.projectService.getProjectId(),
      },
      data: uploadConfig.content
    }) as Promise<any>);
  }
}
